import React from "react";
import styled from "styled-components";
import { colors } from "../utils/helpers";

import moment from "moment";
// import "moment/locale/es";

const FlexItem = styled.div`
	font-size: 0.8em;
	text-align: center;
	width: 130px;
	padding: 0.2em;
	display: flex;
	align-items: center;
	justify-content: space-around;
	cursor: pointer;
	margin: 0 2em 0 2em;
	transition: background 400ms;
	background: ${colors.white};
	@media (max-width: 720px) {
		margin: 0;
		flex: 1 1 50%;
		border-top: 1px solid ${colors.grisclaro};
		border-bottom: 1px solid ${colors.grisclaro};
		height: 70px;
		order: 1;
		&:not(:first-child) {
			border-left: 1px solid ${colors.grisclaro};
		}
		&:hover {
			box-shadow: inset 2px 2px 3px 0px rgba(0, 0, 0, 0.05);
		}
	}
`;

const FlexItemInactivo = FlexItem.extend`
	cursor: default;
`;

const FlexItemCentral = styled.div`
	font-size: 1em;
	padding: 0.2em;
	text-align: center;
	margin: 0 auto;
	@media (max-width: 720px) {
		flex: 1 1 100%;
	}
`;

const FlexContainer = styled.section`
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
	max-width: 1220px;
	margin: 0 auto;
`;

const Dia = styled.h1`
	font-size: 1.4em;
	font-family: ${colors.stackSerif};
	color: ${colors.grisoscuro};
	font-weight: 500;
	margin: 0.8em;
	text-align: center;
	@media (max-width: 720px) {
		font-size: 1.8em;
	}
	@media (min-width: 880px) {
		font-size: 1.8em;
	}
	@media (min-width: 920px) {
		font-size: 2em;
	}
`;

const Paragraph = styled.p`
	color: ${colors.black};
	padding: 0.5em;
	width: 110px;
	font-weight: 400;
	letter-spacing: 0.1em;
	font-size: 1.2em;
	&:hover {
		color: ${colors.main};
	}
`;

const Arrow = styled.svg`
	min-width: 40px;
`;

const ParagraphInactivo = Paragraph.extend`
	color: ${colors.grisclaro};
	&:hover {
		color: ${colors.grisclaro};
	}
`;

const Hoy = styled.h4`
	color: ${colors.grisocuro};
	font-size: 0.8em;
	font-weight: 400;
	text-transform: uppercase;
	text-align: center;
	letter-spacing: 0.07rem;
	margin: 1em;
	margin-top: 1.5em;
	letter-spacing: 0.2em;
`;

class Daynav extends React.Component {
	render() {
		let titulo = () => {
			if (!this.props.tiempo.procesiones[0]) {
				return "No hay procesiones";
			} else {
				let añadido =
					this.props.dia === this.props.dia_act
						? "de hoy"
						: moment(this.props.tiempo.fecha).format("MMM D");
				return "Procesiones " + añadido;
			}
		};

		return (
			<div className="container daynav">
				<FlexContainer className="flexContainer">
					{/* Desactiva botón anterior */}
					{this.props.dia_act !== 1 ? (
						<FlexItem onClick={this.props.diaAnterior}>
							<Arrow
								width="42"
								height="34"
								viewBox="0 0 1000 1000"
								fill={colors.main}
							>
								<path d="M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z" />
							</Arrow>
							<Paragraph>
								{this.props.dia === this.props.dia_act ? "Ayer" : "Anterior"}
							</Paragraph>
						</FlexItem>
					) : (
						<FlexItemInactivo>
							<Arrow
								width="42"
								height="34"
								viewBox="0 0 1000 1000"
								fill={colors.grisclaro}
							>
								<path d="M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z" />
							</Arrow>
							<ParagraphInactivo>
								{this.props.dia === this.props.dia_act ? "Ayer" : "Anterior"}
							</ParagraphInactivo>
						</FlexItemInactivo>
					)}
					<FlexItemCentral>
						<Dia>{this.props.tiempo.evento}</Dia>
					</FlexItemCentral>
					{/* Desactiva botón siguiente */}
					{this.props.dia_act < 10 ? (
						<FlexItem onClick={this.props.diaSiguiente}>
							<Paragraph>
								{this.props.dia === this.props.dia_act ? "Mañana" : "Siguiente"}
							</Paragraph>
							<Arrow
								width="42"
								height="34"
								viewBox="0 0 1000 1000"
								fill={colors.main}
							>
								<path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
							</Arrow>
						</FlexItem>
					) : (
						<FlexItemInactivo>
							<ParagraphInactivo>
								{this.props.dia === this.props.dia_act ? "Mañana" : "Siguiente"}
							</ParagraphInactivo>
							<Arrow
								width="42"
								height="34"
								viewBox="0 0 1000 1000"
								fill={colors.grisclaro}
							>
								<path d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z" />
							</Arrow>
						</FlexItemInactivo>
					)}
				</FlexContainer>
				<Hoy>{titulo()}</Hoy>
			</div>
		);
	}
}

export default Daynav;



// WEBPACK FOOTER //
// ./src/components/Daynav.js